import { useEffect, useRef, useState } from 'react';
import Button from '../../button/v2/button';
import { HStack } from '../../layouts/stack.layout';
import Container from '../container';

const styles = {
  form: 'w-full flex flex-row items-center py-3 mobile:px-1 tablet-lg:px-5 mobile:gap-1 tablet-lg:gap-5',
  'button-group': 'mobile:hidden tablet-lg:flex',
  'dropdown-button': 'mobile:block tablet-lg:hidden',
  textarea:
    'overflow-hidden resize-none w-full block bg-[#08080D] px-5 py-3 border border-dark-gray rounded-[1.5rem] max-h-[6rem]',
};

export default function MessageBox() {
  const textareaRef = useRef(null);
  const [message, setMessage] = useState<string>('');

  const onChange = (value: string) => {
    setMessage(() => value);
  };

  useEffect(() => {
    if (textareaRef && textareaRef.current) {
      // @ts-ignore: Object is possibly 'null'.
      textareaRef.current.style.height = '0px';
      // @ts-ignore: Object is possibly 'null'.
      const scrollHeight = textareaRef.current.scrollHeight;
      // @ts-ignore: Object is possibly 'null'.
      textareaRef.current.style.height = scrollHeight + 'px';
    }
  }, [message]);

  return (
    <form className={styles.form}>
      <HStack gap="base" extensions={styles['button-group']}>
        <Button size="md" color="base-200" asIcon="camera" />
        <Button size="md" color="base-200" asIcon="image" />
      </HStack>
      <Container extensions={styles['dropdown-button']}>
        <Button size="md" color="base-200" asIcon="add" />
      </Container>
      <textarea
        ref={textareaRef}
        className={styles.textarea}
        placeholder="Type message"
        value={message}
        onChange={(e) => onChange(e.target.value)}
      />
      <Button size="md" color="accent" asIcon="send" />
    </form>
  );
}
